<template>
    <el-row :gutter="12">
        <el-col :span="6">
            <card-indicator 
                title="Total" 
                :value="0" 
                typeIconBox="primary"
                type="type-min"
            >
            </card-indicator>
        </el-col>
        <el-col :span="6">
            <card-indicator 
                title="Ativos" 
                :value="0"
                typeIconBox="success"
                type="type-min"
            >
            </card-indicator>
        </el-col>
        <el-col :span="6">
            <card-indicator 
                title="Inativos" 
                :value="0" 
                typeIconBox="warning"
                type="type-min"
            >
            </card-indicator>
        </el-col>

        <el-col :span="6">
            <card-indicator 
                title="Inadiplentes" 
                :value="0" 
                typeIconBox="danger"
                type="type-min"
            >
            </card-indicator>
        </el-col>
    </el-row>
</template>
<script>
    
    import CardIndicator from "@/components/_micro/Card/CardIndicator.vue";

    export default {
        components: {
            CardIndicator,
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/_internal/distribuidor/DistribuidorIndicators.vue